"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GAPageView = exports.GAEvent = void 0;
var react_ga_1 = __importDefault(require("react-ga"));
var requests_1 = require("./requests");
// Checks if reactga has initalised
var hasInit = false;
var getGaId = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, requests_1.get('/api/ga').then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!response.ok) return [3 /*break*/, 2];
                                return [4 /*yield*/, response.text().then(function (gaid) {
                                        react_ga_1.default.initialize(gaid);
                                        hasInit = true;
                                    })];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Send GA Event to record click - customise the category, action and label name to record multiple uniques per session.
 * @param {string} category
 * @param {string} action
 * @param {string} [label='nothing']
 * @param {number} value
 */
var GAEvent = function (category, action, label, value) {
    if (label === void 0) { label = 'nothing'; }
    if (value === void 0) { value = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!hasInit) return [3 /*break*/, 2];
                    return [4 /*yield*/, getGaId()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    react_ga_1.default.event({
                        category: category,
                        action: action,
                        label: label,
                        value: value,
                        nonInteraction: false,
                    });
                    return [2 /*return*/];
            }
        });
    });
};
exports.GAEvent = GAEvent;
/**
 * Send GA Pageview to record time on page - once per session.
 * @param {string} page
 * @param {string} [title=undefined]
 */
var GAPageView = function (page, title) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!hasInit) return [3 /*break*/, 2];
                return [4 /*yield*/, getGaId()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                react_ga_1.default.pageview(page, undefined, title);
                return [2 /*return*/];
        }
    });
}); };
exports.GAPageView = GAPageView;
